import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {connect} from 'react-redux';
import {resetReportWidgetsLoadingState} from '../../../../../../services/redux/actions';
import phantom from '../../../../../../services/phantom';
import ReactGridLayout from 'react-grid-layout';
import Paper from 'material-ui/Paper';
import UpdateReportLayoutMutation from '../../../../../../mutations/UpdateReportLayoutMutation';
import WidgetTypeRouter from '../../../../../../components/WidgetTypeRouter';
import _ from 'lodash';

function getWidgetHeight(layoutItem, rowHeight, rowMargin) {
  const itemHeight = layoutItem ? layoutItem.h : 1; 
  return (itemHeight*(rowHeight+rowMargin))-rowMargin;
}

function getWidgetWidth(layoutItem, gridWidth, columns, columnMargin) {
  const itemWidth = layoutItem ? layoutItem.w : 1
  const singleColumnWidth = (gridWidth-(columnMargin*(columns-1)))/columns;
  return (itemWidth*(singleColumnWidth+columnMargin))-columnMargin;
}

const gridDimensions = {
  width: 1200,
  columns: 12,
  columnMargin: 20,
  rowHeight: 10,
  rowMargin: 20,
};

const styles = {
  paper: {
    height: 100,
    width: 100,
    margin: 0,
    textAlign: 'center',
    display: 'inline-block',
    overflow: 'hidden',
  },
};

@connect()
class AdminReportGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      layout: props.report.layout || [],
    };
  }

  handleLayoutChange = (layout) => {
    const minHeightLayout = layout.map(l => {
      const minHeight = 3;
      if (l.h < minHeight) {
        l.h = minHeight;
      }
      return Object.assign(l, {minH: minHeight});
    });
    // Special rules for page break widgets
    const specialWidgetsLayout = minHeightLayout.map(l => {
      const widget = this.props.report.widgets.find((w) => w.id === l.i);
      if (widget.type === 'page-break') {
        return Object.assign({}, l, {w: 12, h: 3, isResizable: false});
      } else {
        return l;
      }
    });
    this.setState({
      layout: specialWidgetsLayout,
    });
    UpdateReportLayoutMutation.commit({
      reportId: this.props.report.id,
      layout: specialWidgetsLayout,
    });
  };

  componentDidMount() {
    const widgets = this.props.report.widgets;
    if (widgets.length > 0) {
      phantom.reportLoading();
      this.props.dispatch(
        resetReportWidgetsLoadingState(
          this.props.report.id,
          widgets.filter(widget => widget.type !== 'page-break').map(widget => widget.id),
        ),
      );
    } else {
      phantom.reportLoaded();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.report.layout, this.state.layout)) {
      this.setState({
        layout: nextProps.report.layout || [],
      });
    }
  }

  render() {
    const { report, reports, surveys } = this.props;

    return (
      <div style={{marginBottom: '400px'}}>
        <ReactGridLayout 
          className="layout"
          layout={this.state.layout}
          cols={gridDimensions.columns}
          margin={[
            gridDimensions.columnMargin,
            gridDimensions.rowMargin,
          ]}
          containerPadding={[0,0]}
          rowHeight={gridDimensions.rowHeight}
          width={gridDimensions.width}
          onLayoutChange={this.handleLayoutChange}
          isDraggable={true}
          isResizable={true}
        >
          {report.widgets.map((widget) => {
            const layoutItem = this.state.layout.find((l) => l.i === widget.id);
            const height = getWidgetHeight(
              layoutItem,
              gridDimensions.rowHeight,
              gridDimensions.rowMargin,
            );
            const width = getWidgetWidth(
              layoutItem,
              gridDimensions.width,
              gridDimensions.columns,
              gridDimensions.columnMargin,
            );
            return (
              <Paper key={widget.id} style={styles.paper} zDepth={0}>
                <WidgetTypeRouter 
                  widget={widget}
                  report={report}
                  reports={reports}
                  surveys={surveys}
                  height={height}
                  width={width}
                  isAccountAdmin={_.includes(this.props.viewer.roles, 'account_admin')}
                />
              </Paper>
            );
          })}
        </ReactGridLayout>
      </div>
    )
  }
}

export default createFragmentContainer(
  AdminReportGrid,
  graphql`
    fragment AdminReportGrid_viewer on Viewer {
      roles
    }
    fragment AdminReportGrid_report on Report {
      id
      layout {
        i
        x
        y
        w
        h
      }
      widgets {
        id
        type
        ...WidgetTypeRouter_widget
      }
      ...WidgetTypeRouter_report
    }
    fragment AdminReportGrid_surveys on SurveyConnection {
      ...WidgetTypeRouter_surveys
    }
    fragment AdminReportGrid_reports on ReportConnection {
      ...WidgetTypeRouter_reports
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/AdminReportGrid/AdminReportGrid.js